/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

function postBZReviewQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function postBZReviewInput(request: DataServiceEntities.IPostBZReviewRequest): IDataServiceRequest {
    const query = postBZReviewQuery();
    return query.createDataServiceRequestForOperation(
        'PostBZReview',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            request: request
        }
    );
}

export function postBZReviewAsync(context: IContext, _request: DataServiceEntities.IPostBZReviewRequest): AsyncResult<string> {
    const request = postBZReviewInput(_request);
    return callActionOrExecute<string>(request, context.callerContext);
}

function getBZReviewsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getBZReviewsInput(productId: string, pageSize: number, offset: number): IDataServiceRequest {
    const query = getBZReviewsQuery();
    return query.createDataServiceRequestForOperation(
        'GetBZReviews',
        false,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            ProductId: productId,
            PageSize: pageSize,
            Offset: offset
        }
    );
}

export function getBZReviewsAsync(context: IContext, productId: string, pageSize: number, offset: number): AsyncResult<string> {
    const request = getBZReviewsInput(productId, pageSize, offset);
    return callActionOrExecute<string>(request, context.callerContext);
}

function getBZMetadataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getBZMetadataInput(productId: string): IDataServiceRequest {
    const query = getBZMetadataQuery();
    return query.createDataServiceRequestForOperation(
        'GetBZMetadata',
        false,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            ProductId: productId
        }
    );
}

export function getBZMetadataAsync(context: IContext, productId: string): AsyncResult<string> {
    const request = getBZMetadataInput(productId);
    return callActionOrExecute<string>(request, context.callerContext);
}

function beginSessionQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function beginSessionInput(token: string, captcha: string): IDataServiceRequest {
    const query = beginSessionQuery();
    return query.createDataServiceRequestForOperation(
        'BeginSession',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        {
            token: token,
            captcha: captcha
        }
    );
}

export function beginSessionAsync(context: IContext, token: string, captcha: string): AsyncResult<string> {
    const request = beginSessionInput(token, captcha);
    return callActionOrExecute<string>(request, context.callerContext);
}

function getCustomerPaymentDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getCustomerPaymentDataInput(token: string, sessionToken: string): IDataServiceRequest {
    const query = getCustomerPaymentDataQuery();
    return query.createDataServiceRequestForOperation(
        'GetCustomerPaymentData',
        true,
        DataServiceEntities.GetCustomerPaymentDataResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetCustomerPaymentDataResponse' },
        {
            token: token,
            sessionToken: sessionToken
        }
    );
}

export function getCustomerPaymentDataAsync(
    context: IContext,
    token: string,
    sessionToken: string
): AsyncResult<DataServiceEntities.IGetCustomerPaymentDataResponse> {
    const request = getCustomerPaymentDataInput(token, sessionToken);
    return callActionOrExecute<DataServiceEntities.IGetCustomerPaymentDataResponse>(request, context.callerContext);
}

function updateCustomerPaymentDataQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function updateCustomerPaymentDataInput(
    sessionToken: string,
    request: DataServiceEntities.IUpdateCustomerPaymentDataRequest
): IDataServiceRequest {
    const query = updateCustomerPaymentDataQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateCustomerPaymentData',
        true,
        DataServiceEntities.UpdateCustomerPaymentDataResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUpdateCustomerPaymentDataResponse' },
        {
            sessionToken: sessionToken,
            request: request
        }
    );
}

export function updateCustomerPaymentDataAsync(
    context: IContext,
    sessionToken: string,
    _request: DataServiceEntities.IUpdateCustomerPaymentDataRequest
): AsyncResult<DataServiceEntities.IUpdateCustomerPaymentDataResponse> {
    const request = updateCustomerPaymentDataInput(sessionToken, _request);
    return callActionOrExecute<DataServiceEntities.IUpdateCustomerPaymentDataResponse>(request, context.callerContext);
}

function getItemDimensionsQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getItemDimensionsInput(queryResultSettings: IQueryResultSettings, itemIds: string[]): IDataServiceRequest {
    const query = getItemDimensionsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetItemDimensions',
        true,
        DataServiceEntities.ItemDataExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IItemData' },
        {
            itemIds: itemIds
        }
    );
}

export function getItemDimensionsAsync(context: IContext, itemIds: string[]): AsyncResult<DataServiceEntities.IItemData[]> {
    const request = getItemDimensionsInput(context.queryResultSettings || {}, itemIds);
    return callActionOrExecute<DataServiceEntities.IItemData[]>(request, context.callerContext);
}

function getItemTransportationCodesQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getItemTransportationCodesInput(queryResultSettings: IQueryResultSettings, productIds: number[]): IDataServiceRequest {
    const query = getItemTransportationCodesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetItemTransportationCodes',
        true,
        DataServiceEntities.ProductTransportationCodeExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IProductTransportationCode' },
        {
            productIds: productIds
        }
    );
}

export function getItemTransportationCodesAsync(
    context: IContext,
    productIds: number[]
): AsyncResult<DataServiceEntities.IProductTransportationCode[]> {
    const request = getItemTransportationCodesInput(context.queryResultSettings || {}, productIds);
    return callActionOrExecute<DataServiceEntities.IProductTransportationCode[]>(request, context.callerContext);
}

function nSS_UpdateSalesOrderApprovalStatusQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function nSS_UpdateSalesOrderApprovalStatusInput(
    salesOrderId: string,
    approvalStatus: string,
    rejectComments: string
): IDataServiceRequest {
    const query = nSS_UpdateSalesOrderApprovalStatusQuery();
    return query.createDataServiceRequestForOperation(
        'NSS_UpdateSalesOrderApprovalStatus',
        true,
        DataServiceEntities.UpdateSalesOrderApprovalStatusResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse' },
        {
            salesOrderId: salesOrderId,
            approvalStatus: approvalStatus,
            rejectComments: rejectComments
        }
    );
}

export function nSS_UpdateSalesOrderApprovalStatusAsync(
    context: IContext,
    salesOrderId: string,
    approvalStatus: string,
    rejectComments: string
): AsyncResult<DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse> {
    const request = nSS_UpdateSalesOrderApprovalStatusInput(salesOrderId, approvalStatus, rejectComments);
    return callActionOrExecute<DataServiceEntities.IUpdateSalesOrderApprovalStatusResponse>(request, context.callerContext);
}

function nsCustomerOrderHistoryQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function nsCustomerOrderHistoryInput(
    customerId: string,
    businessId: string,
    salesId: string,
    confirmationId: string,
    skip: number,
    top: number
): IDataServiceRequest {
    const query = nsCustomerOrderHistoryQuery();
    return query.createDataServiceRequestForOperation(
        'NsCustomerOrderHistory',
        true,
        DataServiceEntities.GetNsCustomerOrderHistoryResponseExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGetNsCustomerOrderHistoryResponse' },
        {
            CustomerId: customerId,
            BusinessId: businessId,
            SalesId: salesId,
            ConfirmationId: confirmationId,
            Skip: skip,
            Top: top
        }
    );
}

export function nsCustomerOrderHistoryAsync(
    context: IContext,
    customerId: string,
    businessId: string,
    salesId: string,
    confirmationId: string,
    skip: number,
    top: number
): AsyncResult<DataServiceEntities.IGetNsCustomerOrderHistoryResponse> {
    const request = nsCustomerOrderHistoryInput(customerId, businessId, salesId, confirmationId, skip, top);
    return callActionOrExecute<DataServiceEntities.IGetNsCustomerOrderHistoryResponse>(request, context.callerContext);
}

// @ts-ignore
function cCHLogsQuery(replicationCounter?: number): DataServiceQuery {
    const key = replicationCounter ? { ReplicationCounter: replicationCounter } : null;
    return new DataServiceQuery('CCHLogs', 'CCHLog', DataServiceEntities.CCHLogExtensionClass, key);
}

export function createGetCCHLogsInput(queryResultSettings: IQueryResultSettings): IDataServiceRequest {
    const query = cCHLogsQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetCCHLogs',
        true,
        DataServiceEntities.CCHLogExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICCHLog' },
        {}
    );
}

export function getCCHLogsAsync(context: IContext): AsyncResult<DataServiceEntities.ICCHLog[]> {
    const request = createGetCCHLogsInput(context.queryResultSettings || {});
    return callActionOrExecute<DataServiceEntities.ICCHLog[]>(request, context.callerContext);
}
